import { TaskCompletionStateFragment } from "gql/graphql";
import { getTaskDueDate, isRecurringTask, isTaskDone } from "../../completion";

/**
 * Задача просрочена: не выполнена, а срок уже прошёл. Без срока просрочки нет.
 * У серии просрочки нет вовсе: её «срок» — ближайшее срабатывание, оно всегда впереди,
 * а пропущенные итерации сервер считает сам и отдаёт блоком дашборда, не полем задачи.
 */
export function isTaskOverdue(
  task: TaskCompletionStateFragment,
  now: Date = new Date(),
) {
  if (isRecurringTask(task)) {
    return false;
  }

  const dueDate = getTaskDueDate(task);

  return !isTaskDone(task) && !!dueDate && new Date(dueDate) < now;
}
